import React, { useState } from 'react';
import { LayoutComposer } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import css from './ContactPage.module.css';

// Phosphor Icons as React components
const EmailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="#000000"
    viewBox="0 0 256 256"
  >
    <path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM203.43,64,128,133.15,52.57,64ZM216,192H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z"></path>
  </svg>
);

const PhoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="#000000"
    viewBox="0 0 256 256"
  >
    <path d="M144.27,45.93a8,8,0,0,1,9.8-5.66,86.22,86.22,0,0,1,61.66,61.66,8,8,0,0,1-5.66,9.8A8.23,8.23,0,0,1,208,112a8,8,0,0,1-7.73-5.94,70.35,70.35,0,0,0-50.33-50.33A8,8,0,0,1,144.27,45.93Zm-2.33,41.8c13.79,3.68,22.65,12.54,26.33,26.33A8,8,0,0,0,176,120a8.23,8.23,0,0,0,2.07-.27,8,8,0,0,0,5.66-9.8c-5.12-19.16-18.5-32.54-37.66-37.66a8,8,0,1,0-4.13,15.46Zm81.94,95.35A56.26,56.26,0,0,1,168,232C88.6,232,24,167.4,24,88A56.26,56.26,0,0,1,72.92,32.12a16,16,0,0,1,16.62,9.52l21.12,47.15,0,.12A16,16,0,0,1,109.39,104c-.18.27-.37.52-.57.77L88,129.45c7.49,15.22,23.41,31,38.83,38.51l24.34-20.71a8.12,8.12,0,0,1,.75-.56,16,16,0,0,1,15.17-1.4l.13.06,47.11,21.11A16,16,0,0,1,223.88,183.08Zm-15.88-2s-.07,0-.11,0h0l-47-21.05-24.35,20.71a8.44,8.44,0,0,1-.74.56,16,16,0,0,1-15.75,1.14c-18.73-9.05-37.4-27.58-46.46-46.11a16,16,0,0,1,1-15.7,6.13,6.13,0,0,1,.57-.77L96,95.15l-21-47a.61.61,0,0,1,0-.12A40.2,40.2,0,0,0,40,88,128.14,128.14,0,0,0,168,216,40.21,40.21,0,0,0,208,181.07Z"></path>
  </svg>
);

const LocationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="#000000"
    viewBox="0 0 256 256"
  >
    <path d="M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z"></path>
  </svg>
);

const LegalIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="#000000"
    viewBox="0 0 256 256"
  >
    <path d="M243.32,116.69l-16-16a16,16,0,0,0-20.84-1.53L156.84,49.52a16,16,0,0,0-1.52-20.84l-16-16a16,16,0,0,0-22.63,0l-64,64a16,16,0,0,0,0,22.63l16,16a16,16,0,0,0,20.83,1.52L96.69,124,31.31,189.38A25,25,0,0,0,66.63,224.7L132,159.32l7.17,7.16a16,16,0,0,0,1.52,20.84l16,16a16,16,0,0,0,22.63,0l64-64A16,16,0,0,0,243.32,116.69ZM80,104,64,88l64-64,16,16ZM55.32,213.38a9,9,0,0,1-12.69,0,9,9,0,0,1,0-12.68L108,135.32,120.69,148ZM101,105.66,145.66,61,195,110.34,150.35,155ZM168,192l-16-16,4-4h0l56-56h0l4-4,16,16Z"></path>
  </svg>
);

const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const TwitterIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.213c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
  </svg>
);

const InstagramIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

const LinkedinIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    userType: 'consumer',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    // Construct email with form data
    const emailSubject = encodeURIComponent(
      `[BioCerca Contacto] ${formData.subject || 'Consulta'}`
    );

    const emailBody = encodeURIComponent(
      `
Nombre: ${formData.name}
Email: ${formData.email}
Teléfono: ${formData.phone}
Tipo de usuario: ${formData.userType}
Asunto: ${formData.subject}

Mensaje:
${formData.message}
        `.trim()
    );

    // Open user's email client
    window.location.href = `mailto:contacto@biocerca.es?subject=${emailSubject}&body=${emailBody}`;

    // Show success message
    setSubmitStatus('success');

    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
      userType: 'consumer',
    });

    setIsSubmitting(false);
  };

  const layoutAreas = `
        topbar
        main
        footer
    `;

  return (
    <LayoutComposer areas={layoutAreas} className={css.root}>
      {layoutProps => {
        const { Topbar, Main, Footer } = layoutProps;
        return (
          <>
            <Topbar as="header" className={css.topbar}>
              <TopbarContainer currentPage="ContactPage" />
            </Topbar>
            <Main as="main" className={css.main}>
              <div className={css.content}>
                <header className={css.pageHeader}>
                  <h1 className={css.title}>Contacto</h1>
                  <p className={css.subtitle}>
                    Estamos aquí para ayudarte. Cuéntanos cómo podemos asistirte.
                  </p>
                </header>

                <div className={css.contactWrapper}>
                  <div className={css.contactGrid}>
                    {/* Contact Information Card */}
                    <div className={css.infoCard}>
                      <div className={css.cardHeader}>
                        <h2 className={css.infoTitle}>Información de Contacto</h2>
                        <p className={css.infoDescription}>
                          Ponte en contacto con nosotros a través de cualquiera de estos canales
                        </p>
                      </div>

                      <div className={css.infoItems}>
                        <div className={css.infoItem}>
                          <div className={css.infoIcon}>
                            <EmailIcon />
                          </div>
                          <div className={css.infoContent}>
                            <h3 className={css.infoItemTitle}>Email</h3>
                            <p className={css.infoItemText}>contacto@biocerca.es</p>
                            <p className={css.infoItemSubtext}>Respuesta en 24-48 horas</p>
                          </div>
                        </div>

                        <div className={css.infoItem}>
                          <div className={css.infoIcon}>
                            <PhoneIcon />
                          </div>
                          <div className={css.infoContent}>
                            <h3 className={css.infoItemTitle}>Teléfono</h3>
                            <p className={css.infoItemText}>+34 696 867 268</p>
                            <p className={css.infoItemSubtext}>Lunes a Viernes, 9:00 - 18:00</p>
                          </div>
                        </div>


                        <div className={css.infoItem}>
                          <div className={css.infoIcon}>
                            <LegalIcon />
                          </div>
                          <div className={css.infoContent}>
                            <h3 className={css.infoItemTitle}>Aspectos Legales</h3>
                            <p className={css.infoItemText}>legal@biocerca.es</p>
                            <p className={css.infoItemSubtext}>Para consultas legales y términos</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Contact Form Card */}
                    <div className={css.formCard}>
                      <div className={css.cardHeader}>
                        <h2 className={css.formTitle}>Envíanos un Mensaje</h2>
                        <p className={css.formDescription}>
                          Rellena el formulario y nos pondremos en contacto contigo
                        </p>
                      </div>

                      {submitStatus === 'success' && (
                        <div className={css.successMessage}>
                          <div className={css.successIcon}>✓</div>
                          <div className={css.successContent}>
                            <h4 className={css.successTitle}>Mensaje preparado</h4>
                            <p className={css.successText}>
                              Se abrirá tu cliente de correo. Por favor, revisa y envía el email a
                              contacto@biocerca.es
                            </p>
                          </div>
                        </div>
                      )}

                      <form onSubmit={handleSubmit} className={css.form}>
                        <div className={css.formGrid}>
                          <div className={css.formGroup}>
                            <label htmlFor="name" className={css.label}>
                              Nombre completo *
                            </label>
                            <input
                              type="text"
                              id="name"
                              name="name"
                              value={formData.name}
                              onChange={handleInputChange}
                              required
                              className={css.input}
                              placeholder="Tu nombre"
                            />
                          </div>

                          <div className={css.formGroup}>
                            <label htmlFor="email" className={css.label}>
                              Email *
                            </label>
                            <input
                              type="email"
                              id="email"
                              name="email"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                              className={css.input}
                              placeholder="tu@email.com"
                            />
                          </div>
                        </div>

                        <div className={css.formGrid}>
                          <div className={css.formGroup}>
                            <label htmlFor="phone" className={css.label}>
                              Teléfono
                            </label>
                            <input
                              type="tel"
                              id="phone"
                              name="phone"
                              value={formData.phone}
                              onChange={handleInputChange}
                              className={css.input}
                              placeholder="+34 600 000 000"
                            />
                          </div>

                          <div className={css.formGroup}>
                            <label htmlFor="userType" className={css.label}>
                              Tipo de usuario
                            </label>
                            <select
                              id="userType"
                              name="userType"
                              value={formData.userType}
                              onChange={handleInputChange}
                              className={css.select}
                            >
                              <option value="consumer">Consumidor</option>
                              <option value="farmer">Agricultor</option>
                              <option value="collaborator">Colaborador</option>
                              <option value="other">Otro</option>
                            </select>
                          </div>
                        </div>

                        <div className={css.formGroup}>
                          <label htmlFor="subject" className={css.label}>
                            Asunto *
                          </label>
                          <select
                            id="subject"
                            name="subject"
                            value={formData.subject}
                            onChange={handleInputChange}
                            required
                            className={css.select}
                          >
                            <option value="">Selecciona un asunto</option>
                            <option value="general">Consulta general</option>
                            <option value="technical">Problema técnico</option>
                            <option value="account">Problema con mi cuenta</option>
                            <option value="payment">Problema con un pago</option>
                            <option value="collaboration">Propuesta de colaboración</option>
                            <option value="complaint">Reclamación</option>
                            <option value="legal">Consulta legal</option>
                            <option value="other">Otro</option>
                          </select>
                        </div>

                        <div className={css.formGroup}>
                          <label htmlFor="message" className={css.label}>
                            Mensaje *
                          </label>
                          <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleInputChange}
                            required
                            rows={6}
                            className={css.textarea}
                            placeholder="Describe tu consulta o problema..."
                          />
                        </div>

                        <button type="submit" disabled={isSubmitting} className={css.submitButton}>
                          {isSubmitting ? 'Preparando...' : 'Enviar Mensaje'}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </Main>
            <Footer>
              <FooterContainer />
            </Footer>
          </>
        );
      }}
    </LayoutComposer>
  );
};

export default ContactPage;
